import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PpbInvitationComponent } from './ppb-invitation.component';


const routes: Routes = [{ path: '', component: PpbInvitationComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PpbInvitationRoutingModule { }
